import React from 'react';
import styles from './FieldItemList.module.scss';
import { FieldValueType } from '../../../../../Models';
import { SectionFieldItem } from '../SectionField/SectionFieldItem/SectionFieldItem';
import { Divider } from '../../../../Divider/Divider';
import { FieldItemSubList } from './FieldItemSubList/FieldItemSubList';

export type FieldItemListType = {
  label: string;
  type: string;
  value: FieldValueType | FieldItemListType[] | FieldItemListType[][];
};

export interface FieldItemListProps {
  title: string;
  fields: FieldItemListType[];
  hasDivider?: boolean;
}

export const FieldItemList = ({
  title,
  fields,
  hasDivider = false
}: FieldItemListProps): React.ReactElement<FieldItemListProps> => {
  return (
    <div className={styles.fieldItemList}>
      <h4 className={styles.title}>{title}</h4>
      <div className={styles.container}>
        {fields.map((field: FieldItemListType) => {
          if (field.type === 'subList' && Array.isArray(field.value)) {
            return (
              <FieldItemSubList
                key={field.label}
                title={field.label}
                fields={field.value as FieldItemListType[]}
              />
            );
          }
          if (field.type !== 'subList' && field.value) {
            return (
              <SectionFieldItem
                key={field.label}
                label={field.label}
                value={field.value as FieldValueType}
                type={field.type}
              />
            );
          }
          return null;
        })}
        {hasDivider && <Divider />}
      </div>
    </div>
  );
};
